import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

import services from 'api/services';
const { ConfigService } = services;

export const useLanguageVersions = () => {
  const [languageVersions, setLanguageVersions] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(undefined);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const languageVersionsConfig = await ConfigService.getLanguageVersions();
        if (languageVersionsConfig?.value?.[4]?.python) {
          setLanguageVersions(languageVersionsConfig.value);
        } else {
          toast.error('Failed to fetch language versions');
          setError({ message: 'Failed to fetch language versions' });
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return [languageVersions, loading, error];
};
